import {
  configureProductDucks,
  CARD_PRODUCT,
  PERSONAL_SAVINGS_ACCOUNT,
  PERSONAL_CHECKING_ACCOUNT,
  BUSINESS_CHECKING_ACCOUNT,
  KABBAGE_ACCOUNT,
  CROSS_BORDER_PAYMENTS,
  INVESTMENT_ACCOUNT,
  CRYPTO_ACCOUNT,
} from '@americanexpress/product-ducks';
import {
  configureProductDucks as configureProductDucks04,
} from 'axp-product-ducks';
import { RootStateOrAny } from 'react-redux';

export const productTypes = [
  CARD_PRODUCT,
  PERSONAL_CHECKING_ACCOUNT,
  BUSINESS_CHECKING_ACCOUNT,
  PERSONAL_SAVINGS_ACCOUNT,
  KABBAGE_ACCOUNT,
  CROSS_BORDER_PAYMENTS,
  INVESTMENT_ACCOUNT,
  CRYPTO_ACCOUNT,
];

const getToState = (state: RootStateOrAny) => state.getIn(['modules', 'axp-consumer-navigation', 'products']);

const productsDucksConfig = (): void => {
  configureProductDucks({
    getToState,
    defaultTypes: [CARD_PRODUCT],
    filterTypes: productTypes,
    orderTypes: productTypes,
  });

  configureProductDucks04({
    getToState,
    defaultTypes: [CARD_PRODUCT],
    filterTypes: productTypes,
    orderTypes: productTypes,
  });
};

export default productsDucksConfig;
